import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "chevron-up-down_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m12 3.828-6.586 6.586L4 9l8-8 8 8-1.414 1.414L12 3.828ZM12 20.176 5.414 13.59 4 15.004l8 8 8-8-1.414-1.414L12 20.176Z"
    }, null, -1)
  ]))]))
}
export default { render: render }